import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  isDialogOpen = signal<boolean>(false);

  getIsDialogOpen() {
    return this.isDialogOpen;
  }

  setDialogOpen(isOpen: boolean) {
    this.isDialogOpen.set(isOpen);
  }
} 